import { useRef } from 'react';
import { IModalRefProps } from 'ui/components/Modals/Modal/types';

export const useViewGeneralSettingsController = () => {
  const modalEmployeeIdNumberRef = useRef<IModalRefProps>(null);
  const openModalEmployeeIdNumber = () =>
    modalEmployeeIdNumberRef.current?.open();

  return {
    modalEmployeeIdNumberRef,
    openModalEmployeeIdNumber,
  };
};
